import {FacetsState} from "models/FacetsState"
import {Filters} from "models/Filter"

interface NewFiltersState {
    facets: FacetsState
    searchFilters: Filters
}

export const selectedFacetFilterTitle = (value: NewFiltersState) => {
    const arrayOfSelectedFacets: any = []

    Object.entries(value.facets).forEach(([_key, valueOfKey]) => {
        if (valueOfKey.s) {
            arrayOfSelectedFacets.push({value: valueOfKey.v, name: valueOfKey.n})
        }
    })

    const filterFacetSelectionWithSpacingFilters: any = []
    arrayOfSelectedFacets.forEach(entry => {
        const splitSelectedFilterFacetEntry = entry.value.split(":")
        Object.entries(value.searchFilters).forEach(([_key, filterEntry]) => {
            if (filterEntry.name === splitSelectedFilterFacetEntry[0]) {
                // eslint-disable-next-line prettier/prettier
                filterFacetSelectionWithSpacingFilters.push(`${filterEntry.displayName}:${entry.name as string}`)
            }
        })
    })

    const finalFilterFacetSelection: string[] = []
    filterFacetSelectionWithSpacingFilters.forEach(entry => {
        const splitEntry = entry.split(":")
        const containsTheEntryCategoryIndex = finalFilterFacetSelection.findIndex(vel =>
            vel.includes(splitEntry[0].charAt(0).toUpperCase() + splitEntry[0].slice(1)),
        )
        if (containsTheEntryCategoryIndex >= 0) {
            finalFilterFacetSelection[containsTheEntryCategoryIndex] = `${
                finalFilterFacetSelection[containsTheEntryCategoryIndex]
            }, ${splitEntry[1] as string}`
        } else {
            finalFilterFacetSelection.push(
                `${(splitEntry[0] as string).charAt(0).toUpperCase() + splitEntry[0].slice(1)}: ${
                    splitEntry[1] as string
                }`,
            )
        }
    })

    return finalFilterFacetSelection.join(" | ")
}
